export enum PositionEnum {
  // President / Directeur général
  COMPANY_DIRECTOR = 'COMPANY_DIRECTOR',
  // Comptable
  COMPANY_ACCOUNTANT = 'COMPANY_ACCOUNTANT',
  // Responsable RH
  COMPANY_HUMAN_RESOURCE_MANAGER = 'COMPANY_HUMAN_RESOURCE_MANAGER',
  // Responsable commercial
  COMPANY_SALES_ADMINISTRATOR = 'COMPANY_SALES_ADMINISTRATOR',
  // Responsable marketing et communication
  COMPANY_MARKETING_MANAGER = 'COMPANY_MARKETING_MANAGER',
  // Responsable IT
  COMPANY_IT_MANAGER = 'COMPANY_IT_MANAGER',
  // Commercial
  COMPANY_COMMERCIAL = 'COMPANY_COMMERCIAL',
  // Chargé de relations client
  COMPANY_CUSTOMER_SUCCESS = 'COMPANY_CUSTOMER_SUCCESS',
  // Autre opérationnel
  COMPANY_OPERATIONAL = 'COMPANY_OPERATIONAL',
  // Responsable financier
  COMPANY_FINANCE_MANAGER = 'COMPANY_FINANCE_MANAGER',
  // Responsable juridique
  COMPANY_LEGAL_MANAGER = 'COMPANY_LEGAL_MANAGER',
  // Responsable communication
  COMPANY_COMMUNICATION_MANAGER = 'COMPANY_COMMUNICATION_MANAGER',
  // Président
  ASSOCIATION_PRESIDENT = 'ASSOCIATION_PRESIDENT',
  // Trésorier
  ASSOCIATION_ACCOUNTANT = 'ASSOCIATION_ACCOUNTANT',
  // Secrétaire
  ASSOCIATION_SECRETARY = 'ASSOCIATION_SECRETARY',
  // Autre
  OTHER = 'OTHER',
}
